<template>
  <div class="nav-select_nas" :class="{ [curTheme]: true }" v-if="links.length">
    <template v-if="links.length === 1">
      <span class="el-dropdown-link">
        {{ links[activeI].text }}
      </span>
    </template>
    <template v-else-if="links.length > 1 && links.length <= 10">
      <el-dropdown placement="bottom">
        <span class="el-dropdown-link">
          {{ links[activeI].text }}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="(l, i) in links" :key="`link-${i}`">
            <router-link :to="l.url">{{ l.text }}</router-link>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </template>
    <template v-else>
      <el-select
        class="nas_select"
        @change="onChange"
        filterable
        :value="links[activeI].url">
        <el-option
          v-for="(l, i) in links"
          :key="`link2-${i}`"
          :label="l.text"
          :value="l.url">
        </el-option>
      </el-select>
    </template>
  </div>
</template>

<script>
export default {

  data() {
    return {
      links: [],
      activeI: 0,
    };
  },

  created() {
    this.setLinks();
  },

  computed: {
    orgAdminIn() {
      return this.$store.getters['user/getWhereOrgAdmin'];
    },
    orgs() {
      return this.$store.getters['orgs/getOrgs'];
    },
  },

  watch: {
    orgAdminIn() {
      this.setLinks();
    },
    orgs() {
      this.setLinks();
    },
    $route() {
      this.setLinks();
    },
  },

  methods: {

    onChange(url) {
      this.$router.push({ path: url });
    },

    setLinks() {
      this.links = [];
      if (this.orgs.length && this.orgAdminIn.length) {
        this.orgAdminIn.forEach((oaIn) => {
          const org = this.orgs.find(o => o.OrganizationId === oaIn);
          if (org) {
            this.links.push({ url: `/user/organization/${oaIn}`, text: org.Name, orgId: oaIn });
          }
        });
        this.setActive();
      }
    },

    setActive() {
      const activeId = this.$route.params.orgId;
      if (activeId) {
        this.activeI = this.links.findIndex(o => o.orgId === activeId);
      }
    },

  },
};
</script>

<style lang="scss">
@import '../../styles/common/main';

.nav-select_nas {
  text-align: center;
  padding: 20px 10px;
  background: rgba(255, 255, 255, .07);
  margin-bottom: 30px;
  .el-dropdown-link {
    color: #fff;
    font-size: 15px;
    cursor: default;
  }
  .nas_select {
    max-width: 800px;
    .el-input {
      .el-input__inner {
        background: transparent;
        border: 1px solid rgba(255, 255, 255, .1);
        @include box-shadow(none);
      }
      .el-select__caret {
        color: #fff;
      }
    }
  }
  &.theme-w {
    background: rgba(0, 0, 0, .03);
    .el-dropdown-link {
      color: #000;
    }
  }
}
.html_page-form {
  .nav-select_nas {
    background: rgba(255, 255, 255, .07);
    .el-dropdown-link {
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/org-admin/NavUserOrgs.vue